import React from 'react';
import { c as classnames } from './index-2586sEvh.js';
import { formatPrice } from './utils/price.js';

/* eslint-disable react/no-array-index-key */
const ShippingChart = ({ shippingData, currency, locale, noZeroAfterDecimal, andMore }) => (React.createElement("div", { className: "shipping-wrapper" },
    React.createElement("table", { id: "shipping-table", className: "table shipping", cellPadding: "0" },
        React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement("th", null, "Min"),
                React.createElement("th", null, "Max"),
                React.createElement("th", null, "Zone 1"),
                React.createElement("th", null, "Zone 2"),
                React.createElement("th", null, "Zone 3"),
                React.createElement("th", null, "Zone 4")),
            shippingData.map((currentRow, rowIndex) => (React.createElement("tr", { key: rowIndex }, currentRow.map((element, elementIndex) => (React.createElement("td", { key: elementIndex, className: classnames({
                    grey: elementIndex < 2,
                    odd: rowIndex % 2 && elementIndex > 1,
                }) }, parseFloat(element)
                ? formatPrice(parseFloat(element), currency, locale, noZeroAfterDecimal)
                : andMore))))))))));

export { ShippingChart as S };
//# sourceMappingURL=ShippingChart-WhG8PR2C.js.map
